<template>
    <ui-card-base
        v-bind:is-accented="isAccented"
        v-bind:with-border="!isAccented"
        >
        <article class="page-cabinet-dashboard-highlights-card">
            <div class="page-cabinet-dashboard-highlights-card__question">
                <VTooltip
                    v-bind:distance="6"
                    v-bind:triggers="['click', 'hover']"
                    placement="right"
                    >
                    <icon name="question" width="16" height="16" v-bind:color="!isAccented ? '#6737AF' : 'white'"/>
                    <template #popper>
                        <p style="max-width: 300px; font-size: 14px;">
                            {{ description }}
                        </p>
                    </template>
                </VTooltip>
            </div>

            <div class="page-cabinet-dashboard-highlights-card__title"
                v-text="title"
            />
            <div class="page-cabinet-dashboard-highlights-card__info">
                <div class="page-cabinet-dashboard-highlights-card__info-value"
                    v-text="valueFormatted"
                />
                <div class="page-cabinet-dashboard-highlights-card__info-units"
                    v-if="units && units !== '%' && units !== 'x'"
                    v-text="'/' + units"
                />
<!--                <div class="page-cabinet-dashboard-highlights-card__info-delta"
                     v-bind:class="{'_positive': this.delta > 0, '_negative': this.delta < 0}"
                     v-text="delta + '%'"
                     v-if="delta"
                />-->
            </div>
        </article>
    </ui-card-base>
</template>

<script>
import utils from '~/utils';

export default {
    name: 'page-cabinet-dashboard-highlights-card',
    props: {
        isAccented: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        value: {
            type: [ Number, String ],
            default: 0,
        },
        units: {
            type: String,
            default: null,
        },
        delta: {
            type: [ Number, String ],
            default: null,
        },
        description: {
            type: String,
            default: '',
        },
    },
    computed: {
        valueFormatted() {
            let result = this.value;
            if (typeof this.value !== 'number') {
                result = parseFloat(this.value);
            }
            return utils.formats.formatNumberWithSpaces(result) + (this.units && (this.units === '%' || this.units === 'x') ? this.units : '');
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';
.page-cabinet-dashboard-highlights-card {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    color: @color-gray-main;
    ._accented & {
        color: currentColor;
        &__title {
            .typography-heading();

        }
        &__info {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            &-value {
                font-size: 7.2rem;
            }
            &-units {
                font-size: 7.2rem;
            }
        }
        @media @media-lg-down {
            &__title {
                .typography-body();
            }
            &__info {
                margin-top: inherit;
                position: static;
                left: inherit;
                transform: inherit;
                &-value {
                    .typography-large();
                }
                &-units {
                    .typography-large();
                }
            }
        }
    }
    &__title {
        .typography-body();

        margin-bottom: 8px;
        padding-right: 24px;
    }
    &__question {
        position: absolute;
        right: 0;
        top: 0;
        // cursor: pointer;
    }
    &__info {
        display: flex;
        justify-content: flex-start;
        align-items: baseline;
        width: 100%;
        &-value {
            .typography-large();

            color: @color-gray-darker;
            ._accented & {
                color: currentColor;
            }
        }
        &-units {
            .typography-caption();

            margin-left: 4px;

            text-transform: uppercase;
        }
        &-delta {
            .typography-caption();

            position: absolute;
            right: 0;
            bottom: 6px;

            padding: 2px 4px 2px 6px;
            border-radius: @border-radius-sm;
            margin-left: auto;
            margin-right: 0;

            font-weight: bold;
            &._positive {
                color: @color-positive;

                background-color: fade(@color-positive, 10%);

                &:before {
                    content: '+';
                }
            }
            &._negative {
                color: @color-accent-negative;

                background-color: fade(@color-accent-negative, 10%);
            }
        }
    }
}
</style>
